/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/
import { submitNewRequest } from 'backend/requests.jsw';
let request = { owner: '', email: '', phone: '', customerDetails: {}, address: {}, productDetails: {}, faultReason: '', invoice: {} }
import wixWindow from 'wix-window';

$w.onReady(function () {
    initializePage();
});

let x = '';

function initializePage() {
    step1();
    step2();
    step3();
    step4();
    step5();
    step6();

    function step1() {
        $w('#step1NextBtn').onClick(() => {
            if (!$w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').collapse() }

            if ($w('#firstName').value.length > 0) {
                if ($w('#lastName').value.length > 0) {
                    if ($w('#phone').value.length > 0 && $w('#phone').valid) {
                        if ($w('#email').valid && $w('#email').value.length > 0) {
                            if ($w('#customerType').selectedIndex === 2) {
                                goToNextStep();
                            } else {
                                if ($w('#company').enabled && $w('#company').value.length > 0) {
                                    if ($w('#companyNo').enabled && $w('#companyNo').value.length > 0) {
                                        goToNextStep();
                                    } else {
                                        $w('#companyNo').updateValidityIndication();
                                        $w('#companyNo').focus();
                                        $w('#customerDetailsErrorMsg').text = 'אנא הזן את מספר הרישום של החברה.';
                                        if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
                                    }

                                } else {
                                    $w('#company').updateValidityIndication();
                                    $w('#company').focus();
                                    $w('#customerDetailsErrorMsg').text = 'אנא הזן את שם החברה של הלקוח';
                                    if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
                                }
                            }
                        } else {
                            $w('#email').updateValidityIndication();
                            $w('#email').focus();
                            $w('#customerDetailsErrorMsg').text = 'אנא הכנס כתובת דואר אלקטרוני נכונה';
                            if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
                        }
                    } else {
                        $w('#phone').updateValidityIndication();
                        $w('#phone').focus();
                        $w('#customerDetailsErrorMsg').text = 'בבקשה הכנס מספר טלפון תקין.';
                        if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
                    }
                } else {
                    $w('#lastName').updateValidityIndication();
                    $w('#lastName').focus();
                    $w('#customerDetailsErrorMsg').text = 'אנא הזן את שמו הפרטי של הלקוח.';
                    if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
                }
            } else {
                $w('#firstName').updateValidityIndication();
                $w('#firstName').focus();
                $w('#customerDetailsErrorMsg').text = 'אנא הזן את שמו הפרטי של הלקוח.';
                if ($w('#customerDetailsErrorMsg').collapsed) { $w('#customerDetailsErrorMsg').expand() }
            }
        })

        $w('#customerType').onChange(() => {
            let value = $w('#customerType').value;
            if (value === 'Private Customer') {
                if ($w('#company').enabled) {
                    $w('#company').disable();
                    $w('#company').value = '';
                }

                if ($w('#companyNo').enabled) {
                    $w('#companyNo').disable();
                    $w('#companyNo').value = '';
                }
            } else {
                if (!$w('#company').enabled) { $w('#company').enable() }
                if (!$w('#companyNo').enabled) { $w('#companyNo').enable() }
            }
        })

        function goToNextStep() {
            let customerDetails = {
                name: `${$w('#firstName').value} ${$w('#lastName').value}`,
                firstName: $w('#firstName').value,
                lastName: $w('#lastName').value,
                phone: $w('#phone').value,
                email: $w('#email').value,
                type: $w('#customerType').value,
                company: $w('#company').value || null,
                companyNo: $w('#companyNo').value || null
            }

            request.customerDetails = customerDetails;

            $w('#requestStages').changeState('step2').then(() => { // Step 1
                if ($w('#requestProgress').value === 0) { $w('#requestProgress').value = $w('#requestProgress').value + 1 }
            })
        }
    }

    function step2() {
        let addressIsValid = false;

        const validateAddress = () => {
            if (!$w('#customerAddressErrorMsg').collapsed) { $w('#customerAddressErrorMsg').collapse() }
            let address = $w('#address').value;
            addressIsValid = false;

            if (address) {
                if (address.formatted.length > 0) {
                    if (wixWindow.viewMode === 'Preview' || (typeof address.location.latitude === 'number' && typeof address.location.longitude === 'number')) {
                        addressIsValid = true;
                        return Promise.resolve();
                    } else {
                        $w('#address').updateValidityIndication();
                        $w('#address').focus();
                        $w('#customerAddressErrorMsg').text = 'הכתובת אינה חוקית, אנא הוסף כתובת חוקית.';
                        if ($w('#customerAddressErrorMsg').collapsed) { $w('#customerAddressErrorMsg').expand() }
                    }
                } else {
                    $w('#address').updateValidityIndication();
                    $w('#address').focus();
                    $w('#customerAddressErrorMsg').text = 'אנא הזן תחילה את כתובתך.';
                    if ($w('#customerAddressErrorMsg').collapsed) { $w('#customerAddressErrorMsg').expand() }
                }
            } else {
                $w('#address').updateValidityIndication();
                $w('#address').focus();
                $w('#customerAddressErrorMsg').text = 'אנא הזן תחילה את כתובתך.';
                if ($w('#customerAddressErrorMsg').collapsed) { $w('#customerAddressErrorMsg').expand() }
            }

            return Promise.reject();
        }

        $w('#step2NextBtn').onClick(async () => {
            await validateAddress().then(() => {
                goToNextStep();
            })
        })

        $w('#address').onCustomValidation((value, reject) => {
            addressIsValid = false;
            let enabled = false;
            if (value) {
                if (value.formatted) {
                    $w('#validateAddress').enable();
                    enabled = true
                }
            }

            if (!enabled) {
                $w('#validateAddress, #step2NextBtn').disable();
            }
        })

        $w('#address').onFocus(() => {
            $w('#step2NextBtn').disable();
            $w('#validateAddress').enable();
        })

        $w('#validateAddress').onClick(() => {
            $w('#validateAddress').disable().then(async () => {
                await validateAddress().then(() => {
                    if (addressIsValid) {
                        if (!$w('#step2NextBtn').enabled) { $w('#step2NextBtn').enable() }
                    } else {
                        if ($w('#step2NextBtn').enabled) { $w('#step2NextBtn').disable() }
                    }
                })
            })
        })

        function goToNextStep() {
            let addressObj = $w('#address').value
            let address = { city: addressObj.city, street: addressObj.streetAddress }
            request.address = addressObj; // Disable temporarily
            //request.address = addressObj.formatted;

            $w('#requestStages').changeState('step3').then(() => { // Step 2
                if ($w('#requestProgress').value === 1) { $w('#requestProgress').value = $w('#requestProgress').value + 1 }
            })
        }
    }

    function step3() {
        $w('#purchaseDate').onChange(() => {
            validatePurchaseDate().then(() => {
                if (!$w('#purchaseDateError').collapsed) { $w('#purchaseDateError').collapse() }
            }).catch(err => {
                $w('#purchaseDate').updateValidityIndication();
                $w('#purchaseDate').focus();
                $w('#purchaseDateError').text = err;
                if ($w('#purchaseDateError').collapsed) { $w('#purchaseDateError').expand() }
            })
        })

        $w('#productType').onChange(() => {
            const value = $w('#productType').value.toLowerCase();

            if (value === 'iphone') {
                $w('#serial').value = '';
                if (!$w('#imei').enabled) { $w('#imei').enable().then(() => $w('#imei').focus()) } else { $w('#imei').focus() }
            } else {
                $w('#imei').value = '';
                if (!$w('#serial').enabled) { $w('#serial').enable().then(() => $w('#serial').focus()) } else { $w('#serial').focus() }
                if ($w('#imei').enabled) { $w('#imei').disable() }
            }

            if (value === 'iphone' || value === 'ipod' || value === 'ipad' || value === 'imac' || value === 'macbook' || value === 'apple tv') {
                if (!$w('#devicePassword').enabled) { $w('#devicePassword').enable() }
            } else {
                if ($w('#devicePassword').enabled) { $w('#devicePassword').disable() }
                $w('#devicePassword').value = '';
            }

        })

        function validatePurchaseDate() {
            if (!$w('#purchaseDateError').collapsed) { $w('#purchaseDateError').collapse() }
            const selectedDate = $w('#purchaseDate').value;
            const now = new Date();

            if (selectedDate) {
                if (selectedDate.getFullYear() <= now.getFullYear()) {
                    if (now.getFullYear() === selectedDate.getFullYear()) {

                        if (selectedDate.getMonth() <= now.getMonth()) {
                            return Promise.resolve();
                        } else {
                            // You cannot select a purchase date in the future.
                            return Promise.reject('אינך יכול לבחור תאריך רכישה בעתיד.');
                        }
                    } else {
                        if (now.getFullYear() - selectedDate.getFullYear() <= 10) {
                            return Promise.resolve();
                        } else {
                            // The the purchase date is too old.
                            return Promise.reject('תאריך הרכישה ישן מדי.');
                        }
                    }
                } else {
                    // You cannot select a purchase date in the future.
                    return Promise.reject('אינך יכול לבחור תאריך רכישה בעתיד.');
                }
            } else {
                // Please select the purchase date first.
                return Promise.reject('אנא בחר את תאריך הרכישה תחילה.');
            }

        }

        const validateSerial = () => {
            if ($w('#serial').validity.valid && $w('#serial').value.length > 0) {
                return Promise.resolve();
            } else {
                return Promise.reject($w('#serial').validationMessage);
            }
        }

        const validateIMEI = () => {
            if (!$w('#imei').enabled) {
                return Promise.resolve();
            } else {
                if ($w('#imei').value.length > 0) {
                    if ($w('#imei').value.length >= 15) {
                        return Promise.resolve();
                    } else {
                        return Promise.reject('ה- IMEI צריך להיות באורך של לפחות 15 תווים.');
                    }
                } else {
                    return Promise.reject('אנא ציין אם המוצר הוא באחריות השנה הראשונה שלו או לא');
                }
            }
        }

        $w('#step3NextBtn').onClick(async () => {
            if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }

            if ($w('#productType').value !== '') {
                validateSerial().then(() => {
                    validateIMEI().then(() => {
                        validatePurchaseDate().then(() => {
                            if (!$w('#purchaseDateError').collapsed) { $w('#purchaseDateError').collapse() }

                            if ($w('#purchaseLocation').value.length > 0) {
                                if ($w('#firstYearWarranty').value !== '') {
                                    goToNextStep();
                                } else {
                                    $w('#firstYearWarranty').updateValidityIndication();
                                    $w('#productDetailsErrorMsg').text = 'אנא ספר לנו אם המכשיר שלך נמצא באחריות לשנה הראשונה או לא.';
                                    if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                                }
                            } else {
                                $w('#purchaseLocation').updateValidityIndication();
                                $w('#purchaseLocation').focus();
                                $w('#productDetailsErrorMsg').text = 'אנא הזן את המקום בו קנית את המכשיר.';
                                if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                            }
                        }).catch(err => {
                            $w('#purchaseDate').updateValidityIndication();
                            $w('#purchaseDate').focus();
                            $w('#purchaseDateError').text = err;
                            if ($w('#purchaseDateError').collapsed) { $w('#purchaseDateError').expand() }
                        })
                    }).catch(err => {
                        $w('#imei').updateValidityIndication();
                        $w('#imei').focus();
                        $w('#productDetailsErrorMsg').text = err;
                        if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                    })
                }).catch(err => {
                    $w('#serial').updateValidityIndication();
                    $w('#serial').focus();
                    $w('#productDetailsErrorMsg').text = err;
                    if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                })

            } else {
                $w('#productType').updateValidityIndication();
                $w('#productDetailsErrorMsg').text = 'אנא בחר את סוג המוצר';
                if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
            }
        })

        $w('#imei').onCustomValidation((value, reject) => {
            if (value.length > 0) {
                if ($w('#imei').validity.patternMismatch) {
                    $w('#productDetailsErrorMsg').text = 'אנא הזן IMEI. מותר רק תווים ומספרים נטויים.';
                    reject('אנא הזן IMEI. מותר רק תווים ומספרים נטויים.');
                    if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                } else {
                    if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }
                }
            } else {
                if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }
            }
        })

        $w('#serial').onCustomValidation((value, reject) => {
            if (value.length > 0) {
                if (!value.includes(" ")) {
                    if (value.length === 12) {
                        if ($w('#serial').validity.patternMismatch) {
                            $w('#productDetailsErrorMsg').text = "אנא הזן מספר סידורי תקף. רק תווים אלפאנומריים, קו נטוי אחורי (/), מקפים (-) וקווים תחתונים (_) מותרים.";
                            reject("אנא הזן מספר סידורי תקף. רק תווים אלפאנומריים, קו נטוי אחורי (/), מקפים (-) וקווים תחתונים (_) מותרים.");
                        } else {
                            $w('#serial').resetValidityIndication();
                            if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }
                        }
                    } else {
                        reject('המספר הסידורי חייב להיות באורך של 12 תווים.')
                    }
                } else {
                    reject('המספר הסידורי לא יכול לכלול רווחים.');
                }

            } else {
                if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }
            }
        })

        let serialTimer;
        $w('#serial').onInput((serialEvent) => {
            if (serialTimer) {
                clearTimeout(serialTimer);
                serialTimer = undefined;
            }

            serialTimer = setTimeout(() => {
                let event = serialEvent.target.value;
                serialEvent.target.value = event;

                if ($w('#serial').validity.valid) {
                    if (!$w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').collapse() }
                } else {
                    $w('#productDetailsErrorMsg').text = $w('#serial').validationMessage;
                    if ($w('#productDetailsErrorMsg').collapsed) { $w('#productDetailsErrorMsg').expand() }
                }
            }, 20)
        })

        $w('#terms').onChange(() => {
            if ($w('#terms').checked) { $w('#step3NextBtn').enable() } else { $w('#step3NextBtn').disable() }
        })

        function goToNextStep() {
            const productDetails = {
                type: $w('#productType').value,
                serial: $w('#serial').value || null,
                imei: $w('#imei').value || null,
                firstYearWarranty: null,
                password: $w('#devicePassword').value || null,
                purchaseDate: `${$w('#purchaseDate').value.getFullYear()}/${$w('#purchaseDate').value.getMonth()+1}/${$w('#purchaseDate').value.getDate()}` || null,
                purchaseLocation: $w('#purchaseLocation').value || null
            }

            if ($w('#firstYearWarranty').value === 'Yes') { productDetails.firstYearWarranty = true } else { productDetails.firstYearWarranty = false }
            request.productDetails = productDetails;
            $w('#header').scrollTo();
            $w('#requestStages').changeState('step4').then(() => { // Step 3
                if ($w('#requestProgress').value === 2) { $w('#requestProgress').value = $w('#requestProgress').value + 1 }
            })
        }
    }

    function step4() {
        $w('#step4NextBtn').onClick(() => {
            if (!$w('#productFaultErrorMsg').collapsed) { $w('#productFaultErrorMsg').collapse() }

            if ($w('#fault').value.length > 0) {
                goToNextStep();
                if ($w('#fault').value.length > 25) {
                    goToNextStep();
                } else {
                    $w('#fault').updateValidityIndication();
                    $w('#fault').focus();
                    $w('#productFaultErrorMsg').text = 'תיאור הבעיה קצר מדי, אנא הוסף פרטים נוספים.';
                    $w('#productFaultErrorMsg').expand();
                }
            } else {
                $w('#fault').updateValidityIndication();
                $w('#fault').focus();
                $w('#productFaultErrorMsg').text = 'אנא ספר לנו מה לא בסדר במוצר זה.';
                $w('#productFaultErrorMsg').expand();
            }
        })

        function goToNextStep() {
            request.faultReason = $w('#fault').value;

            $w('#requestStages').changeState('step5').then(() => { // Step 4
                if ($w('#requestProgress').value === 3) { $w('#requestProgress').value = $w('#requestProgress').value + 1 }
            })
        }
    }

    function step5() {
        let invoice = { type: null, url: null }
        let validInvoiceImage = false;
        let validInvoicePdf = false;

        $w('#step5NextBtn').onClick(() => {
            if (!$w('#uploadInvoiceErrorMsg').collapsed) { $w('#uploadInvoiceErrorMsg').collapse() }

            if ($w('#invoiceType').value === 'image') {
                if (validInvoiceImage && $w('#invoicePicBox').currentState.id === 'invoiceImageState' && $w('#uploadedInvoiceImage').src !== 'wix:image://v1/72ffe6_f38ba803628b4cecad81bddf4620efea~mv2.jpg/_.jpg#originWidth=500&originHeight=500') {
                    goToNextStep();
                } else {
                    $w('#uploadInvoiceErrorMsg').text = 'אנא העלה תחילה את חשבונית הרכישה';
                    $w('#uploadInvoiceErrorMsg').expand();
                }
            } else if ($w('#invoiceType').value === 'pdf') {
                if (validInvoicePdf && $w('#invoicePicBox').currentState.id === 'invoicePdfState') {
                    goToNextStep();
                } else {
                    $w('#uploadInvoiceErrorMsg').text = 'העלה חשבונית PDF תקפה לרכישתך';
                    $w('#uploadInvoiceErrorMsg').expand();
                }
            } else {
                goToNextStep();
                //$w('#uploadInvoiceErrorMsg').text = 'אנא בחר תחילה את סוג החשבונית ואז העלה אותה'; // Select the invoice type
                //$w('#uploadInvoiceErrorMsg').expand();
            }

        })

        function goToNextStep() {
            request.invoice = invoice;
            $w('#requestStages').changeState('step6').then(() => { // Step 5
                if ($w('#requestProgress').value === 4) { $w('#requestProgress').value = $w('#requestProgress').value + 1 }
            })
        }

        $w('#invoiceType').onChange(() => {
            $w('#startUploadingIncoice').disable();
            invoice.type = $w('#invoiceType').value;

            if (invoice.type === 'image' || invoice.type === 'pdf') {
                if (invoice.type === 'image' && validInvoiceImage) {
                    $w('#invoicePicBox').changeState('invoiceImageState');
                    $w('#invoiceUploadBtn').fileType = "Image";
                }

                if (invoice.type === 'pdf' && validInvoicePdf) {
                    $w('#invoicePicBox').changeState('invoicePdfState');
                    $w('#invoiceUploadBtn').fileType = "Document";
                }

                if (!validInvoiceImage && !validInvoicePdf) {
                    $w('#invoicePicBox').changeState('noInvoice');
                    $w('#invoiceUploadBtn').reset();
                    if (!$w('#invoiceUploadBtn').enabled) { $w('#invoiceUploadBtn').enable() }
                    if (!$w('#uploadInvoiceError').collapsed) { $w('#uploadInvoiceError').collapse() }
                }
            } else {
                $w('#invoicePicBox').changeState('noInvoice');
                $w('#invoiceUploadBtn').reset();
                if ($w('#invoiceUploadBtn').enabled) { $w('#invoiceUploadBtn').disable() }
                if ($w('#startUploadingIncoice').enabled) { $w('#startUploadingIncoice').disable() }
                if (!$w('#uploadInvoiceError').collapsed) { $w('#uploadInvoiceError').collapse() }
            }

        })

        $w('#invoiceUploadBtn').onChange(() => {
            let value = $w('#invoiceUploadBtn').value[0];
            $w('#uploadInvoiceError, #uploadInvoiceErrorMsg').collapse();

            if (value && $w('#invoiceUploadBtn').valid) {
                if (value.size < 1e+7) {

                    if ($w('#invoiceType').value === 'pdf') {
                        if (value.name.endsWith('.pdf')) {
                            $w('#startUploadingIncoice').enable();
                        } else {
                            $w('#startUploadingIncoice').disable();
                            $w('#uploadInvoiceError').text = "סוג המסמך שנבחר אינו PDF, אנא בחר מסמך PDF.";
                            $w('#uploadInvoiceError').expand();
                            $w('#invoiceUploadBtn').reset();
                        }
                    } else {
                        $w('#startUploadingIncoice').enable();
                    }
                } else {
                    $w('#startUploadingIncoice').disable();
                    let type;
                    if (invoice.type === 'image') { type = 'תמונה' } else { type = 'PDF' }
                    $w('#uploadInvoiceError').text = `העלאה ${type} לא יכולה להיות גדולה מ- 10MB`;
                    $w('#uploadInvoiceError').expand();
                }
            } else {
                $w('#startUploadingIncoice').disable();
            }
        })

        $w('#startUploadingIncoice').onClick(async () => {
            $w('#startUploadingIncoice').disable();
            $w('#uploadInvoiceError, #uploadInvoiceErrorMsg').collapse();
            $w('#uploadingInvoice').show();

            await $w('#invoiceUploadBtn').startUpload().then((uploadedFile) => {
                $w('#uploadingInvoice').hide();

                if (invoice.type === 'image') {
                    if (uploadedFile.width >= 1500 && uploadedFile.height >= 1500) {
                        invoice = { type: $w('#invoiceType').value, url: uploadedFile.url, width: uploadedFile.width, height: uploadedFile.height }
                        $w('#uploadedInvoiceImage').src = invoice.url;
                        $w('#invoicePicBox').changeState('invoiceImageState');
                        validInvoiceImage = true;
                        validInvoicePdf = false;
                        $w('#startUploadingIncoice').disable();
                        $w('#invoiceUploadBtn').reset();
                        $w('#resetInvoice').enable();
                    } else {
                        $w('#uploadInvoiceError').text = 'העלה תמונה ברזולוציה גבוהה יותר מ (1500 פיקסלים × 1500 פיקסלים).';
                        $w('#uploadInvoiceError').expand();
                    }
                } else {
                    invoice = { type: $w('#invoiceType').value, url: uploadedFile.url }
                    $w('#invoicePicBox').changeState('invoicePdfState');
                    validInvoicePdf = true;
                    validInvoiceImage = false;
                    $w('#startUploadingIncoice').disable();
                    $w('#invoiceUploadBtn').reset();
                    $w('#resetInvoice').enable();
                }
            }).catch(err => console.error(err))
        })

        $w('#resetInvoice').onClick(() => {
            validInvoiceImage = false;
            validInvoicePdf = false;
            $w('#invoicePicBox').changeState('noInvoice');
            if ($w('#uploadedInvoiceImage').src !== 'wix:image://v1/72ffe6_f38ba803628b4cecad81bddf4620efea~mv2.jpg/_.jpg#originWidth=500&originHeight=500') { $w('#uploadedInvoiceImage').src = 'wix:image://v1/72ffe6_f38ba803628b4cecad81bddf4620efea~mv2.jpg/_.jpg#originWidth=500&originHeight=500'; }
            $w('#invoiceUploadBtn').reset();
            $w('#uploadInvoiceError, #uploadInvoiceErrorMsg').collapse();
            $w('#startUploadingIncoice, #resetInvoice').disable();
        })
    }

    function step6() {
        let captchaToken = null;
        $w('#submittingLoading').scrolling = 'no';

        $w('#captcha').onTimeout(() => {
            $w('#submitRequest').disable();
            $w('#captchaErrorMsg').text = 'תם הזמן הקצוב של Google Captcha, אנא בצע שוב את אתגר ה- captcha.';
            $w('#captchaErrorMsg').expand();
        })

        $w('#captcha').onVerified(() => {
            $w('#captchaErrorMsg').collapse();
            captchaToken = $w('#captcha').token;
            $w('#submitRequest').enable();
        })

        $w('#submitRequest').onClick(() => {
            $w('#requestStages').changeState('submittingRequest').then(async () => {
                $w('#submitRequest').disable();
                $w('#captcha').reset();

                await submitNewRequest(request, captchaToken).then((result) => {
                    if (result.type === 'success') {
                        $w('#requestProgress').value = $w('#requestProgress').value + 1;
                        $w('#requestStages').changeState('success');
                    } else if (result.type === 'authorization error') {
                        $w('#captchaErrorMsg').text = result.message;
                        $w('#captchaErrorMsg').expand()
                        $w('#requestStages').changeState('step6');
                    } else {
                        $w('#universalError').text = result.message;
                        $w('#requestStages').changeState('error');
                    }
                }).catch(err => {
                    console.error(err);
                    $w('#universalError').text = `An Error Occurred! - ${err}.`
                    $w('#requestStages').changeState('error');
                })
            })
        })
    }
}
/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/